import { useState } from 'react';
import Axios from '../utils/axiosInstance';

const useOrderDetailbyNumber = () => {
  const [orderByEmail, setOrderByEmail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchOrder = async (orderNumber, orderEmail) => {
    setLoading(true);
    setError(null);
    try {
      const response = await Axios.post(`${process.env.REACT_APP_API_BASE_URL}shipment/track-order/`, 
         { "email": orderEmail, "order_number": orderNumber },
      );
      
      setOrderByEmail(response.data.results[0]);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { orderByEmail, loading, error, fetchOrder };
};

export default useOrderDetailbyNumber;
